import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Typography from '@material-ui/core/Typography';

var FragmentContainer = function FragmentContainer(_ref) {
  var children = _ref.children,
      title = _ref.title,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["children", "title", "style"]);

  return React.createElement("div", Object.assign({
    style: _objectSpread({
      marginBottom: 8 * 2,
      marginTop: 8
    }, style)
  }, rest), React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: 1
    }
  }, title), children);
};

FragmentContainer.defaultProps = {
  style: {}
};
export default FragmentContainer;